import { http } from './config';

const CONCESSIONARIAS_PATH = 'concessionarias';

export default {
  listar: ({ page = 1, nome = '', limit }) => {
    let params = `page=${page}`;
    if (nome) params += `&nome=${nome}`;
    if (limit) params += `&limit=${limit}`;
    return http.get(`${CONCESSIONARIAS_PATH}?${params}`);
  },

  salvar: ({ nome }) => http.post(CONCESSIONARIAS_PATH, { nome }),

  atualizar: ({ _id, nome }) =>
    http.post(`${CONCESSIONARIAS_PATH}/${_id}`, { nome }),

  deletar: ({ _id }) => http.delete(`${CONCESSIONARIAS_PATH}/${_id}`)
};
